import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@heroui/react';
import React from 'react';

export interface ConfirmLastRoleModalProps {
  isOpen: boolean;
  memberName: string;
  isWorking: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Asked when the role being removed is the only one the person holds, because
 * removing it takes them out of the workspace too. The service refuses that
 * until the caller says it is intended, so this is the asking.
 */
export const ConfirmLastRoleModal: React.FC<ConfirmLastRoleModalProps> = ({
  isOpen,
  memberName,
  isWorking,
  onConfirm,
  onCancel,
}) => (
  <Modal isOpen={isOpen} onClose={onCancel} size="sm">
    <ModalContent>
      <ModalHeader>Remove their last role?</ModalHeader>
      <ModalBody>
        <p className="text-small text-default-500">
          {memberName} has no other role here, so this removes them from the
          workspace.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button variant="light" onPress={onCancel} isDisabled={isWorking}>
          Cancel
        </Button>
        <Button
          color="danger"
          onPress={onConfirm}
          isLoading={isWorking}
          isDisabled={isWorking}
        >
          Remove
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
